import firebase from 'firebase';

import "firebase/analytics";
import "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBVcmmSxgjlMuwApntCMM_ksgzwROFDjVU",
    authDomain: "hoken-sc.firebaseapp.com",
    projectId: "hoken-sc",
    storageBucket: "hoken-sc.appspot.com",
    messagingSenderId: "602433497528",
    appId: "1:602433497528:web:727e2e5a85885d3583474d",
    measurementId: "G-2SVXC41L5X"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebase;